import React from 'react';
import Styles from './NavCard.module.scss';
/**
 * NavCard Component
 *
 * Renders a navigation card with an icon, title, and description.
 * The card supports customizable background colors and click handling.
 *
 * @component
 * @param {function} t - Translation function to localize text.  
 *                              Accepts a string key and returns a translated string.
 * @param {Object} item - Data object containing card details.
 * @param {string} item.backgroundColor - Background color of the card .
 * @param {string} item.iconColor - Background color of the icon wrapper.
 * @param {JSX.Element} item.icon - Icon component to display inside the card.
 * @param {string} item.title - Title of the card.
 * @param {string} item.description - Description of the card.
 * @param {string} item.path - Path for the card.
 * @param {function} onClick - Click handler function for the card.
 *
 */
export function NavCard({ t, item, onClick }) {
    return (
        <div
            className={Styles.card}
            style={{ backgroundColor: item.backgroundColor }}
            onClick={onClick}
        >
            <div className={Styles.iconWrapper} style={{ backgroundColor: item.iconColor }}>
                {item.icon}
            </div>
            <h3 className={Styles.title}>{t(item.title)}</h3>
            <p className={Styles.desc}>{t(item.description)}</p>
        </div>
    );
};